// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0waL9","suggest":"styles_suggest__K45ii","suggestItem":"styles_suggestItem__fiMtV","selected":"styles_selected__CeatI"};